import { render, staticRenderFns } from "./RequestGeneralInfo.vue?vue&type=template&id=67c0f148&"
import script from "./RequestGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./RequestGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QSelect,QIcon,QBtn,QTooltip,QInput,QItemSection,QItemLabel,QExpansionItem,QDialog,QToolbar,QField,Ripple,ClosePopup} from 'quasar'
component.options.components = Object.assign({QItem,QSelect,QIcon,QBtn,QTooltip,QInput,QItemSection,QItemLabel,QExpansionItem,QDialog,QToolbar,QField}, component.options.components || {})
component.options.directives = Object.assign({Ripple,ClosePopup}, component.options.directives || {})
